//输入控件
import React, { Component } from 'react';
import { TopNavPage, NavUtils } from 'mutants-mobile-navigator';
import { Modal, List, Button, WhiteSpace, WingBlank, Icon } from 'antd-mobile';
import tools from '../utils/tools';
import './DropdownAndExplain.less';
import {Ticon} from '../index';

class DropdownAndExplain extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
    this.state = { 
      show: props.fromPage ? true : false,
      explainContent: [
        {
          level: '一级',
          levelName: '山东省',
          ID: '01'
        },
        {
          level: '二级',
          levelName: '青岛市',
          ID: '02'
        },
        {
          level: '末级',
          levelName: '崂山区',
          ID: '03'
        }
      ]
    }
  }
  /*================自定义事件====================*/

  renderImgContent() {
    const { explainContent } = this.state;
    const { defaulItem } = this.props;
    let defaultArr = []
    if (defaulItem && defaulItem.ID.length > 1) {
      defaultArr = defaulItem && defaulItem.Name.split('+');
    } else {
      defaultArr.push(defaulItem.Name)
    }

    return (<div className='explainImg'>
      <div className='title'>
        选择分类固定显示设置项
      </div>
      <p>分类示意</p>
      <div className='explainImgContent'>
        { explainContent && explainContent.map(item => (
            <div className='contentBox'>
              <div className='first-child'>{item.level}</div>
              <div className={`second-child ${defaultArr.indexOf(item.level) > -1 ? 'choosedLevel' : ''}`}>{item.levelName}</div> 
            </div>
          ))
        }
      </div>
    </div>)
  }
  
  renderContent() {
    const { IsFreeItem, dataSource, value, defaulItem } = this.props;
    if (!dataSource) {
      return null;
    }
    this.selectValue = IsFreeItem ? value : value ? value.ID : -1;
    return dataSource.map(item => {
      let className = item.ID == this.selectValue ? 'dropdownItemSelect' : 'dropdownItem';
      return (
        <div onClick={this.itemClick} data-value={item.ID} className={className}>
          {item.Name}
          {defaulItem && defaulItem.ID == item.ID && <Ticon type='gouxuan' style={{color: '#3688FF'}}></Ticon>}
        </div>
      );
    });
  }

  itemClick = (e) => {
    tools.preventEvent(e);
    const { dataSource } = this.props;
    const selectValue = e.target.attributes['data-value'].value
    dataSource.forEach(item => {
      if (item.ID == selectValue) {
        const { onChange } = this.props;
        if (onChange)
          onChange(item);
      }
    })
  }

  render() {
    const { Title, value, showExplainImg } = this.props;
    const displayValue = value && value.Name ? value.Name : '';
    const className = this.state.show ? 'icon-shouqitubiao1' : 'icon-zhankaitubiao1';
    return (<div className='dropdown' onClick={this.onShow}><span className='title'>{displayValue}</span>
      <Modal
        popup
        visible={this.state.show}
        animationType="slide-up">
        <div className='dropdownContent'>
            {showExplainImg && this.renderImgContent()}
            {this.renderContent()}
        </div>
        <div className='btnArea'>
            <div className='cancelBtn' type="primary" onClick={this.cancel}>取消</div>
            <div className='definedBtn' type="primary" onClick={this.save}>确定</div>
          </div>
      </Modal><span className={`icon iconfont ${className} dropBtn`} /></div>);
  }

  cancel = (e) => {
    tools.preventEvent(e);
    this.onClose();
  }
  
  save = (e) => {
    tools.preventEvent(e);
    const {dataSource, defaulItem, onChange } = this.props;
    dataSource.forEach(item => {
      if (item.ID == defaulItem.ID) {
        if (onChange)
          onChange(item);
      }
    })
    this.onClose();
  }

  onClose = () => {
    this.setState({
      show: false
    });
  }

  onShow = () => {
    this.setState({
      show: true
    });
  }

}
export default DropdownAndExplain;
